export default {"src":"/_next/static/media/walletconnect.6e156f87.svg","height":32,"width":32};